<!-- CYCLE MANAGEMENT TAB -->
<div class="cycles-tab-shell">
   <div class="card admin-card">
      <div
         class="card-head"
         style="margin-bottom: 4px; margin-top: -10px">
         <div class="card-title">Review Cycle Configuration</div>
         <div style="font-size: 13px; color: var(--muted)">Enable or disable cycles and set their active date windows.</div>
      </div>

      <div
         class="loading"
         *ngIf="cyclesLoading">
         Loading cycles…
      </div>

      <div
         *ngIf="!cyclesLoading"
         class="cycles-table">
         <div class="cycles-col-header">
            <div class="cycles-col-bar"></div>
            <div class="cycles-col-name">Cycle</div>
            <div class="cycles-col-status">Status</div>
            <div class="cycles-col-date">Opens</div>
            <div class="cycles-col-date">Closes</div>
            <div
               class="cycles-col-toggle"
               style="padding-left: 30px">
               Enabled
            </div>
         </div>

         <!-- aDVM group row -->
         <div class="cycles-group-row">
            <div class="cycles-group-bar"></div>
            <div class="cycles-group-cell">
               <div class="cycles-icon-bubble">
                  <i class="fas fa-user-md"></i>
               </div>
               <div>
                  <span
                     class="cycles-group-name"
                     style="display: inline-block">
                     aDVM
                  </span>
                  <span class="cycles-group-count">{{ getAdvmActiveCount() }} of 4 active</span>
                  <span class="cycles-group-sub">Associate DVM</span>
               </div>
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
         </div>

         <ng-container *ngFor="let group of cycleGroups">
            <!-- DVM child row (Q1-Q4) -->
            <div
               *ngIf="group.isChild && !group.isTeamChild"
               class="cycles-data-row"
               [class.cycles-data-row--last-child]="group.isLast"
               [class.cycles-row-inactive]="!cycleConfig[group.key].isEnabled">
               <div
                  class="cycles-status-bar"
                  [class.cycles-bar-off]="!cycleConfig[group.key].isEnabled"></div>
               <div class="cycles-indent-cell">
                  <div class="cycles-tree-line"></div>
                  <div>
                     <p
                        class="cycles-child-name"
                        [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                        {{ group.label }}
                     </p>
                  </div>
               </div>
               <div>
                  <span
                     class="cycles-status-badge"
                     [class.cycles-badge-on]="cycleConfig[group.key].isEnabled"
                     [class.cycles-badge-off]="!cycleConfig[group.key].isEnabled">
                     ● {{ cycleConfig[group.key].isEnabled ? "Active" : "Inactive" }}
                  </span>
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].openDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].closeDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div class="cycles-toggle-wrap">
                  <div
                     class="cycles-toggle"
                     [class.cycles-toggle-off]="!cycleConfig[group.key].isEnabled"
                     (click)="toggleCycle(group.key)"></div>
                  <span
                     class="cycles-toggle-label"
                     [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                     {{ cycleConfig[group.key].isEnabled ? "On" : "Off" }}
                  </span>
               </div>
            </div>

            <!-- TEAM group header row -->
            <div
               *ngIf="group.key === 'CLINICAL'"
               class="cycles-group-row">
               <div class="cycles-group-bar"></div>
               <div class="cycles-group-cell">
                  <div class="cycles-icon-bubble">
                     <i class="fas fa-users"></i>
                  </div>
                  <div>
                     <span
                        class="cycles-group-name"
                        style="display: inline-block">
                        TEAM
                     </span>
                     <span class="cycles-group-count">{{ getTeamActiveCount() }} of 3 active</span>
                     <span class="cycles-group-sub">Team Member</span>
                  </div>
               </div>
               <div></div>
               <div></div>
               <div></div>
               <div></div>
            </div>

            <!-- TEAM child rows -->
            <div
               *ngIf="group.isTeamChild"
               class="cycles-data-row"
               [class.cycles-data-row--last-child]="group.isLast"
               [class.cycles-row-inactive]="!cycleConfig[group.key].isEnabled">
               <div
                  class="cycles-status-bar"
                  [class.cycles-bar-off]="!cycleConfig[group.key].isEnabled"></div>
               <div class="cycles-indent-cell">
                  <div class="cycles-tree-line"></div>
                  <div>
                     <p
                        class="cycles-child-name"
                        [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                        {{ group.label }}
                     </p>
                  </div>
               </div>
               <div>
                  <span
                     class="cycles-status-badge"
                     [class.cycles-badge-on]="cycleConfig[group.key].isEnabled"
                     [class.cycles-badge-off]="!cycleConfig[group.key].isEnabled">
                     ● {{ cycleConfig[group.key].isEnabled ? "Active" : "Inactive" }}
                  </span>
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].openDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].closeDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div class="cycles-toggle-wrap">
                  <div
                     class="cycles-toggle"
                     [class.cycles-toggle-off]="!cycleConfig[group.key].isEnabled"
                     (click)="toggleCycle(group.key)"></div>
                  <span
                     class="cycles-toggle-label"
                     [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                     {{ cycleConfig[group.key].isEnabled ? "On" : "Off" }}
                  </span>
               </div>
            </div>

            <div
               *ngIf="!group.isChild && !group.isTeamChild && group.key !== 'CLINICAL'"
               class="cycles-group-row cycles-group-row--flat cycles-group-row--no-border"
               [class.cycles-row-inactive]="!cycleConfig[group.key].isEnabled">
               <div
                  class="cycles-status-bar cycles-bar-flat"
                  [class.cycles-bar-off]="!cycleConfig[group.key].isEnabled"></div>
               <div class="cycles-group-cell">
                  <div
                     class="cycles-icon-bubble"
                     [class.cycles-icon-bubble-off]="!cycleConfig[group.key].isEnabled">
                     <i [class]="'fas ' + group.icon"></i>
                  </div>
                  <div>
                     <span
                        class="cycles-group-name"
                        [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                        {{ group.label }}
                     </span>
                     <span class="cycles-group-sub">{{ group.sub }}</span>
                  </div>
               </div>
               <div>
                  <span
                     class="cycles-status-badge"
                     [class.cycles-badge-on]="cycleConfig[group.key].isEnabled"
                     [class.cycles-badge-off]="!cycleConfig[group.key].isEnabled">
                     ● {{ cycleConfig[group.key].isEnabled ? "Active" : "Inactive" }}
                  </span>
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].openDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div>
                  <input
                     class="cycles-date-input"
                     [class.cycles-date-dim]="!cycleConfig[group.key].isEnabled"
                     type="date"
                     [(ngModel)]="cycleConfig[group.key].closeDate"
                     [disabled]="!cycleConfig[group.key].isEnabled" />
               </div>
               <div class="cycles-toggle-wrap">
                  <div
                     class="cycles-toggle"
                     [class.cycles-toggle-off]="!cycleConfig[group.key].isEnabled"
                     (click)="toggleCycle(group.key)"></div>
                  <span
                     class="cycles-toggle-label"
                     [class.cycles-dim]="!cycleConfig[group.key].isEnabled">
                     {{ cycleConfig[group.key].isEnabled ? "On" : "Off" }}
                  </span>
               </div>
            </div>
         </ng-container>
      </div>

      <div class="cycles-save-bar">
         <span
            class="cycles-save-message cycles-save-success"
            *ngIf="cyclesSaveSuccess">
            {{ cyclesSaveSuccess }}
         </span>
         <span
            class="cycles-save-message cycles-save-error"
            *ngIf="cyclesSaveError">
            {{ cyclesSaveError }}
         </span>
         <button
            class="v-button v-button-md v-gray"
            (click)="discardCycleChanges()"
            [disabled]="cyclesSaving">
            Discard changes
         </button>
         <button
            class="v-button v-button-md v-teal"
            (click)="saveCycleConfig()"
            [disabled]="cyclesSaving">
            <span *ngIf="!cyclesSaving">Save all changes</span>
            <span
               *ngIf="cyclesSaving"
               class="spinnerSave"></span>
         </button>
      </div>
   </div>
</div>
